'use strict';

angular.module('substoreApp.controllers')
    .controller('orderadministrationsummaryController', OrderadministrationsummaryController);

function OrderadministrationsummaryController($scope, $routeParams, dialogData, uiservice, sessionData, productDataCollector, orderProductTermsConfirmation, htmlTruster, webtrekk) {

    $scope.isMyProductsActive = true;

    $scope.breadcrumb.init("navigation_myproducts", "#/myproducts");
    $scope.breadcrumb.add("administration");

    $scope.progressBar.setup({ step: 2, administration: true });

    $scope.confirmation = orderProductTermsConfirmation();

    var subscriptionTemplateId = $routeParams.subscriptionTemplateId;
    var uniqueSubscriptionId = $routeParams.uniqueSubscriptionId;
    var requestedParameterValue = $routeParams.requestedParameterValue;

    function initDialogData() {
        var data = $scope.data = dialogData;

        productDataCollector.collect(data.product);

        $scope.updateTeaser(
            data.product.texts.headerTitleAdministrationSummary,
            data.product.texts.headerSubTitleAdministrationSummary,
            data.product.images.headerImageAdministrationSummary);

        htmlTruster.trust(data.product);

        $scope.footnotes = data.product.productDescription.footnotes;

        $scope.applyFeature($scope, [ data.partnerName, 'orderadministrationsummary', 'dialog' ]);

        webtrekk.track('order_administration_summary', {
            page_content_id: data.product.texts.productName.toString() + "-" + data.product.subscriptionTemplateId,
            shop_product_sku: data.product.subscriptionTemplateId
        });
    }

    // configure routing dialog functions

    $scope.nextClicked = false;

    $scope.next = function () {
        if ($scope.nextClicked)
            return;

        if ($scope.confirmation.failed(
                null,
                null,
                $scope.data.product.textLists.textToBeConfirmedAdministrationSummary,
                $scope.data.product.textLists.textToBeConfirmedChangeSummary,
                null))
            return;

        $scope.nextClicked = true;

        uiservice.orderAdministrationAction({
                sessionId: sessionData.sessionId,
                subscriptionTemplateId: subscriptionTemplateId,
                uniqueSubscriptionId: uniqueSubscriptionId,
                requestedParameterValue: requestedParameterValue
            },
            function success(response) {
                $scope.go("/orderadministrationconfirmation/" + subscriptionTemplateId + "/" + uniqueSubscriptionId);
            },
            $scope.throwServiceResponseFault
        );
    };

    $scope.cancel = function () {
        if ($scope.nextClicked)
            return;
        $scope.nextClicked = true;
        $scope.go("/myproducts");
    };

    $scope.change = function () {
        if ($scope.nextClicked)
            return;
        $scope.nextClicked = true;
        $scope.go('/orderadministrationselection/' + subscriptionTemplateId + '/' + uniqueSubscriptionId + "/" + requestedParameterValue);
    };

    initDialogData();
}